import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { FuzzerRule } from '../models/FuzzerRule';

export class FuzzerRuleMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): FuzzerRule {
    return new FuzzerRule(data.number, data.title, data.category, data.ruleset, data.shortExplanation ?? '');
  }
}
